import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Alert.module.scss';
import clsx from 'clsx';
const Alert = ({ children, type }) => {
  return (
    <>
      <div className={clsx(styles.alert, type == 'error' && styles.alertError, type == 'success' && styles.alertSuccess)}>{children}</div>
    </>
  );
};

export default Alert;
